// extracted by mini-css-extract-plugin
export default {"breadcrumbsRow":"Kp-z","breadcrumbForward":"Lp-z","breadcrumbBack":"Mp-z","selected":"Np-z"};